var map = {
	"./airdrop-rounded.svg": 9160,
	"./bluetooth-rounded.svg": 1544,
	"./focus-rounded.svg": 7619,
	"./screen-mirroring.svg": 161,
	"./sound.svg": 6921,
	"./stage-manager.svg": 7314,
	"./sun.svg": 4395,
	"./switch.svg": 5505,
	"./wifi-rounded.svg": 6411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2024;